import * as React from "react";

import i18n from '@client-shared/lib/i18n';
import * as api from '@client-shared/services/api';
import { handleDisplayErrorData } from '../../services/api/utilities/handleDisplayErrorData';
import { useIsGetAuthRoute } from "../auth/SFDCAuthProvider";
import { useSFDCAuthState } from "../auth/useSFDCAuthState";
import { initialState, reducer, setLoading, setServices } from "./actions";
import { ServicesContextState } from "./types";

const defaultContextState: ServicesContextState = [initialState, () => undefined];

export const ServicesContext = React.createContext(defaultContextState);

type Props = {
  children: React.ReactNode;
};

export const ServicesProvider: React.FC<Props> = ({ children }: Props) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const isAuthRoute = useIsGetAuthRoute();
  const [{ sfdcIdToken }] = useSFDCAuthState();
  React.useEffect(() => {
    if (isAuthRoute) return;
    const fetchServices = async () => {
      try {
        console.log("Fetching services");
        const services = await api.getServices("remote");
        dispatch(setServices(services));
        dispatch(setLoading(false));
      } catch (e) {
        console.log("Error in fetching services", e);
        handleDisplayErrorData(i18n.t("apiErrorMessages.getServices.message"), i18n.t("apiErrorMessages.getServices.title"), e as Error);
      } finally {
        dispatch(setLoading(false));
      }
    };
    if (state.loading && sfdcIdToken) {
      fetchServices();
    }
  }, [state.loading, isAuthRoute, sfdcIdToken]);

  const contextValue: ServicesContextState = React.useMemo(() => [state, dispatch], [state, dispatch]);
  return <ServicesContext.Provider value={contextValue}>{children}</ServicesContext.Provider>;
};
